module.exports = __webpack_public_path__ + "img/sample-score-2.cec19d14.png";